import { render } from "./TestResultOverallDiagnosis.vue?vue&type=template&id=66115192&scoped=true"
import script from "./TestResultOverallDiagnosis.vue?vue&type=script&lang=js"
export * from "./TestResultOverallDiagnosis.vue?vue&type=script&lang=js"

import "./TestResultOverallDiagnosis.vue?vue&type=style&index=0&id=66115192&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66115192"]])

export default __exports__